import * as React from 'react';
import ChevronDownOutlined from './chevron-down-outlined';
import ChevronDownFilled from './chevron-down-filled';
import type { IconCombinedProps } from './types';
const ChevronDownCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ChevronDownFilled ref={ref} {...rest} />;
  }
  return <ChevronDownOutlined ref={ref} {...rest} />;
});
export default ChevronDownCombined;